import React from "react";
import { useTranslation } from "react-i18next";
import {
    ModalOverlay,
    ModalContent,
    ModalTitle,
    ModalText,
    ModalButtons,
    ModalButton,
} from "./styled";
import { useDialogA11y } from "../shared/useDialogA11y";

type DeleteConfirmModalProps = {
    mainColor: string;
    onCancel: () => void;
    onConfirm: () => void;
};

export function DeleteConfirmModal({
    mainColor,
    onCancel,
    onConfirm,
}: DeleteConfirmModalProps): JSX.Element {
    const { t } = useTranslation();
    const { dialogRef, titleId } = useDialogA11y({ onCancel });
    return (
        <ModalOverlay onClick={onCancel}>
            <ModalContent
                ref={dialogRef}
                role="dialog"
                aria-modal="true"
                aria-labelledby={titleId}
                data-testid="scan-to-offers-delete-modal"
                onClick={(e) => e.stopPropagation()}
            >
                <ModalTitle id={titleId}>{t("Delete offer")}</ModalTitle>
                <ModalText>
                    {t("Do you want to confirm the deletion of this offer?")}
                </ModalText>
                <ModalButtons>
                    <ModalButton
                        data-testid="scan-to-offers-delete-cancel"
                        onClick={onCancel}
                    >
                        {t("Cancel")}
                    </ModalButton>
                    <ModalButton
                        data-testid="scan-to-offers-delete-confirm"
                        variant="danger"
                        mainColor={mainColor}
                        onClick={onConfirm}
                    >
                        {t("Delete")}
                    </ModalButton>
                </ModalButtons>
            </ModalContent>
        </ModalOverlay>
    );
}
